import React, { Component, createRef } from 'react'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Hidden,
} from '@material-ui/core'
import {
  Add,
  MoreVert,
  DragIndicator,
  Delete,
  Edit,
  AccessTime,
} from '@material-ui/icons'
import { DragSource, DropTarget } from 'react-dnd'
import EntityTypeIcon from 'utils/EntityTypeIcon'
import Stats from './TaskStats'
import Button from 'components/theme/Button'
import {
  moveStageTask,
  toggleTaskModal,
  removeStageTask,
  addPlaceholderTask,
} from 'actions/campaign/addOrEdit'
import { createOrUpdateCampaign } from 'actions/campaign'
import { update } from 'actions/data'
import { flow } from 'lodash'
// import { SUCCESS } from 'utils/statusConstants'
import classNames from 'classnames'
import taskTypeIDToNameMap from 'utils/taskTypeIDToNameMap'
import secondsToTimeUnits from 'utils/secondsToTimeUnits'
import language from 'utils/vast-languagepack'
import { stepperGoTo } from 'actions/view'
import { currentlyUsedTaskTypesByIDSelector } from 'selectors/tasks'
import ClickableTooltip from 'components/theme/ClickableTooltip'
import TooltipContent from 'components/A2P10DLC/TooltipContent'
import { receiveTask } from 'actions/tasks'

const Task = flow(
  DragSource(
    'task',
    {
      beginDrag(props) {
        return {
          id: props.id,
          index: props.index,
          task: props.task,
          width: props.width,
        }
      },
    },
    (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging(),
      canDrag: (props, monitor) => props.status !== 'L' && props.status !== 'C',
    }),
  ),
  DropTarget(
    'task',
    {
      hover(props, monitor, component) {
        const dragItem = monitor?.getItem()
        const dragIndex = dragItem?.index
        const hoverIndex = props.index
        if (dragIndex === hoverIndex) {
          return
        }
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()
        const hoverMiddleY =
          (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
        const clientOffset = monitor.getClientOffset()
        const hoverClientY = clientOffset.y - hoverBoundingRect.top
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
          return
        }
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
          return
        }
        // if (props.status !== 'L' && props.status !== 'C') {
        Promise.resolve(props.moveStageTask(dragIndex, hoverIndex)).then(() => {
          if (dragItem?.id?.slice(0, 12) !== 'placeholder_') {
            props.createOrUpdateCampaign()
          }
        })
        // }
        monitor.getItem().index = hoverIndex
      },
    },
    (connect, monitor) => ({
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      didDrop: monitor.didDrop(),
      // connectDragPreview: connect.dragPreview(),
    }),
  ),
)(
  class TaskComponent extends Component {
    constructor(props) {
      super(props)
      this.state = { anchorEl: null, offsetWidth: 0 }
      this.delayRef = createRef()
    }

    componentDidMount() {
      if (this.delayRef.current) {
        this.setState({ offsetWidth: this.delayRef.current.offsetWidth })
      }
    }

    render() {
      const {
        connectDragSource,
        connectDropTarget,
        task,
        stageIdx,
        classes,
        removeStageTask,
        update,
        stageId,
        campaignID,
        status,
        index,
        toggleTaskModal,
        isOver,
        tasksLength,
        template,
        groupObj,
        // stepperGoTo,
      } = this.props

      const descriptionTextObj =
        task?.id?.slice?.(0, 12) === 'placeholder_'
          ? {
              1: 'This placeholder task for sending an email will not be saved unless it is edited.',
              2: 'This placeholder task for sending a text message will not be saved unless it is edited.',
              4: 'This placeholder task for adding a contact to a group will not be saved unless it is edited.',
              5: 'This placeholder task for removing a contact from a group will not be saved unless it is edited.',
              6: 'This placeholder task for moving a contact between groups will not be saved unless it is edited.',
            }
          : {
              1: `Subject: ${template?.Template?.SubjectPart || 'Unknown'}`,
              2: task?.send_sms?.trigger_data?.body,
              4: `Add to group '${groupObj?.contactgroup?.name}'`,
              5: `Remove from group '${groupObj?.contactgroup?.name}'`,
              6: `Move from group '${groupObj?.removefrom_contactgroup?.name}' to group '${groupObj?.addto_contactgroup?.name}'`,
            }

      const descriptionText = descriptionTextObj?.[task?.task_type_id]

      const name = nonDelayWidth => {
        return (
          <div
            style={{
              width: `calc(100% - (${nonDelayWidth}px))`,
              // width: `calc(100% - 84px)`,
            }}
            className={classNames(
              classes.name,
              task.sms_stats || task.email_stats
                ? classes.marginTopStats
                : descriptionText
                ? classes.marginTopDescription
                : classes.marginTopNoStats,
            )}
          >
            <span
              style={{
                display: 'table-cell',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                userSelect: 'none',
                // cursor: 'default',
              }}
            >
              {task.name}
            </span>
          </div>
        )
      }

      const description = nonDelayWidth =>
        descriptionText ? (
          <div
            style={{
              fontSize: '0.75rem',
              lineHeight: '1em',
              width: `calc(100% - (${nonDelayWidth}px))`,
              // width: `calc(100% - 84px)`,
            }}
            className={classNames(
              classes.name,
              // task.sms_stats || task.email_stats
              // 	? classes.marginTopStats
              // 	: classes.marginTopNoStats,
            )}
          >
            <span
              style={{
                display: 'table-cell',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                userSelect: 'none',
                // cursor: 'default',
              }}
            >
              {descriptionText}
            </span>
          </div>
        ) : null

      const delay_seconds =
        task?.[taskTypeIDToNameMap?.[task?.task_type_id]?.payload_name]
          ?.delay_seconds

      const post_delay_wallclock =
        task?.[taskTypeIDToNameMap?.[task?.task_type_id]?.payload_name]
          ?.post_delay_wallclock

      const date = new Date()
      if (post_delay_wallclock?.slice) {
        date.setUTCHours(post_delay_wallclock.slice(0, 2))
        date.setUTCMinutes(post_delay_wallclock.slice(3, 5))
      }

      return (
        task &&
        connectDragSource &&
        connectDropTarget &&
        connectDragSource(
          connectDropTarget(
            <div
              style={{
                backgroundColor:
                  task?.id?.slice?.(0, 12) === 'placeholder_'
                    ? '#f9f9f9'
                    : '#d6e6f8',
                borderRadius: 20,
                border: `${isOver ? 4 : 2}px solid #494769`,
                minHeight: 67,
                marginBottom: 25,
                padding: 10,
                position: 'relative',
                marginTop: 25,
                transform: 'translate(0, 0)',
                cursor: 'pointer',
                marginLeft: 48,
              }}
              onClick={() => {
                // if (task.task_type_id === '1') {
                //   stepperGoTo(3, 'task')
                // } else {
                //   stepperGoTo(2, 'task')
                // }

                // console.log('task:')
                // console.log(task)
                // console.log('')
                // console.log('slice():')
                // console.log(task?.id?.slice?.(0, 12))
                Promise.resolve(this.props.receiveTask(null)).then(() => {
                  toggleTaskModal({
                    taskID: task?.id,
                    placeholder:
                      task?.id?.slice?.(0, 12) === 'placeholder_'
                        ? true
                        : undefined,
                    stageIdx,
                    taskTypeID: task?.task_type_id || task?.taskTypeID,
                    taskIndexInStage: index,
                    name: task?.name,
                  })
                })
              }}
            >
              <div className={classNames(classes.numberIcon)}>
                {parseInt(index) + 1}
              </div>
              <div
                style={{
                  position: 'absolute',
                  left: -35,
                  top: task.sms_stats || task.email_stats ? 61 : 60,
                  width: 2,
                  height: 'calc(100% - 24px)',
                  backgroundColor: '#034c94',
                  display: tasksLength === index + 1 ? 'none' : 'block',
                }}
              />
              <DragIndicator className={classes.dragIndicator} />
              <EntityTypeIcon
                entityType="task"
                entityID={task?.task_type_id}
                className={classes.entityTypeIcon}
              />
              <Hidden mdUp>{name(67)}</Hidden>
              <Hidden smDown>{name(87)}</Hidden>
              {Boolean(delay_seconds) || post_delay_wallclock ? (
                <div
                  ref={this.delayRef}
                  className={classNames(
                    classes.delay,
                    // task?.sms_stats || task?.email_stats
                    // 	? classes.delayTopStats
                    // 	: classes.delayTopNoStats,
                  )}
                >
                  {Boolean(delay_seconds) && (
                    <>
                      <div style={{ display: 'inline-block', marginRight: 5 }}>
                        {secondsToTimeUnits(delay_seconds)}
                      </div>
                      <div
                        style={{ display: 'inline-block' }}
                        className={classes.delayText}
                      >
                        <AccessTime classes={{ root: classes.delayIconRoot }} />{' '}
                        {language.campaign.add.delay}
                      </div>
                    </>
                  )}
                  {Boolean(delay_seconds) && post_delay_wallclock && ' | '}
                  {post_delay_wallclock && (
                    <div style={{ display: 'inline-block' }}>
                      Time of day:{' '}
                      {date.toLocaleTimeString([], {
                        hour: 'numeric',
                        minute: '2-digit',
                      })}
                    </div>
                  )}
                </div>
              ) : null}
              <div className={classes.stats}>
                <Stats task={task} />
              </div>
              <Hidden mdUp>{description(67)}</Hidden>
              <Hidden smDown>{description(87)}</Hidden>
              <IconButton
                disabled={status === 'L' || status === 'C'}
                style={{
                  position: 'absolute',
                  right: 4,
                  top: '50%',
                  transform: 'translate(0, -50%)',
                  padding: 2,
                }}
                aria-owns={
                  this.state.anchorEl
                    ? `stageMenu${stageIdx}eventGoal${task.id}`
                    : undefined
                }
                aria-haspopup="true"
                onClick={e => {
                  e.stopPropagation()
                  this.setState({ anchorEl: e.currentTarget })
                }}
                disableRipple
                disableTouchRipple
              >
                <MoreVert />
              </IconButton>
              <Menu
                id={`stageMenu${stageIdx}task${task.id}`}
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={e => {
                  e.stopPropagation()
                  this.setState({ anchorEl: null })
                }}
              >
                <MenuItem
                  onClick={e => {
                    e.stopPropagation()
                    this.setState({ anchorEl: null })
                    // if (task.task_type_id === '1') {
                    //   stepperGoTo(3, 'task')
                    // } else {
                    //   stepperGoTo(2, 'task')
                    // }
                    toggleTaskModal({
                      taskID: task?.id,
                      placeholder:
                        task?.id?.slice?.(0, 12) === 'placeholder_'
                          ? true
                          : undefined,
                      stageIdx,
                      taskTypeID: task?.task_type_id || task?.taskTypeID,
                      taskIndexInStage: index,
                      name: task?.name,
                    })
                  }}
                >
                  <ListItemIcon className={classes.icon}>
                    <Edit />
                  </ListItemIcon>
                  <ListItemText
                    classes={{
                      primary: classes.primary,
                      root: classes.listItemTextRoot,
                    }}
                    primary={language.campaign.add.editTask}
                  />
                </MenuItem>
                <MenuItem
                  onClick={e => {
                    e.stopPropagation()
                    this.setState({ anchorEl: null })
                    if (task?.id?.slice?.(0, 12) === 'placeholder_') {
                      return removeStageTask(stageIdx, index)
                    }
                    return Promise.resolve(
                      removeStageTask(stageIdx, index),
                    ).then(() =>
                      update(
                        null,
                        'campaign',
                        `/${campaignID}/stage/${stageId}/task/${task.id}/remove`,
                      ),
                    )
                  }}
                >
                  <ListItemIcon className={classes.icon}>
                    <Delete />
                  </ListItemIcon>
                  <ListItemText
                    classes={{
                      primary: classes.primary,
                      root: classes.listItemTextRoot,
                    }}
                    primary={language.campaign.add.removeTask}
                  />
                </MenuItem>
              </Menu>
            </div>,
          ),
        )
      )
    }
  },
)

export default connect(
  (state, { stageIdx }) => {
    const campaign = state.campaign.addOrEdit.campaign
    const taskIDs = campaign?.stages?.[stageIdx]?.tasks
    const tasksByID = state.tasks.tasksByID
    const placeholderTasks = campaign.placeholderTasks
    const filteredTaskIDs = taskIDs?.filter?.(
      taskID => tasksByID[taskID] || placeholderTasks[taskID],
    )
    const filteredTasks =
      filteredTaskIDs?.map?.(
        taskID => tasksByID[taskID] || placeholderTasks[taskID],
      ) || []

    const filteredTemplates = filteredTasks?.reduce?.((acc, el) => {
      if (el?.send_email) {
        acc[el?.id] =
          state?.email?.templatesById?.[
            el?.send_email?.trigger_data?.template_id
          ]
      }
      return acc
    }, {})

    const filteredGroups = filteredTasks?.reduce?.((acc, el) => {
      const typeId = parseInt(el?.task_type_id || 0)
      if (typeId > 3 && typeId < 7) {
        const trigger_data =
          el?.[taskTypeIDToNameMap?.[typeId]?.payload_name]?.trigger_data
        if (trigger_data?.contactgroup_id) {
          acc[el?.id] = {
            contactgroup:
              state.contacts?.groupsByID?.[trigger_data?.contactgroup_id],
          }
        }
        if (
          trigger_data?.removefrom_contactgroup_id ||
          trigger_data?.addto_contactgroup_id
        ) {
          acc[el?.id] = {
            removefrom_contactgroup:
              state.contacts?.groupsByID?.[
                trigger_data?.removefrom_contactgroup_id
              ],
            addto_contactgroup:
              state.contacts?.groupsByID?.[trigger_data?.addto_contactgroup_id],
          }
        }
      }
      return acc
    }, {})

    return {
      filteredTasks,
      filteredTemplates,
      filteredGroups,
      // taskIDs: campaign?.stages?.[stageIdx]?.tasks,
      // tasksByID: state.tasks.tasksByID,
      tasksLoaded: state.loadStatus.tasks,
      status: campaign.status,
      taskTypes: currentlyUsedTaskTypesByIDSelector(state),
      approvedCampaignExists: Object.values(
        Object.values(state.data.a2p10dlc || {})?.[0]?.campaigns || {},
      ).some(
        campaign => campaign?.campaignStatus?.slice?.(0, 8) === 'VERIFIED',
      ),
    }
  },
  dispatch =>
    bindActionCreators(
      {
        moveStageTask,
        toggleTaskModal,
        createOrUpdateCampaign,
        removeStageTask,
        update,
        stepperGoTo,
        addPlaceholderTask,
        receiveTask,
      },
      dispatch,
    ),
)(
  withStyles(theme => ({
    addButton: {
      position: 'absolute',
      top: 8,
      right: 40,
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
        top: 10,
        right: 12,
      },
    },
    addIcon: {
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
    dragIndicator: {
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      left: 7,
      cursor: 'grab',
      fill: 'rgba(0, 0, 0, 0.24)',
      [theme.breakpoints.down('sm')]: {
        left: 2,
        // top: 22,
        fontSize: 18,
      },
    },
    entityTypeIcon: {
      fill: '#494769',
      position: 'absolute',
      left: '29px',
      top: '50%',
      transform: 'translate(0, -50%)',
      width: '37px',
      height: '37px',
      [theme.breakpoints.down('sm')]: {
        left: 18,
        width: 27,
      },
    },
    name: {
      marginLeft: 63,
      color: '#494769',
      display: 'table',
      tableLayout: 'fixed',
      whiteSpace: 'nowrap',
      // width: 'calc(100% - 133px)',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 40,
        fontSize: 14,
      },
    },
    marginTopNoStats: {
      marginTop: 11,
      [theme.breakpoints.down('sm')]: {
        marginTop: 13,
      },
    },
    marginTopStats: {
      marginTop: 0,
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },
    },
    marginTopDescription: {
      marginTop: 5,
      [theme.breakpoints.down('sm')]: {
        marginTop: 6,
      },
    },
    delay: {
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%, 0)',
      top: -24,
      color: '#494769',
      textAlign: 'center',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
        top: -21,
      },
    },
    delayText: {
      fontSize: 11,
    },
    delayIconRoot: {
      fontSize: 12,
      verticalAlign: 'top',
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
    delayTopNoStats: {
      top: 15,
      [theme.breakpoints.down('sm')]: {
        top: 17,
      },
    },
    delayTopStats: {
      top: '50%',
      transform: 'translate(0, -50%)',
      // [theme.breakpoints.down('sm')]: {
      // 	top: 1,
      // },
    },
    stats: {
      marginLeft: 60,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 40,
      },
    },
    numberIcon: {
      position: 'absolute',
      left: -49,
      borderRadius: '50%',
      width: 30,
      height: 30,
      color: '#fff',
      textAlign: 'center',
      paddingTop: 8,
      fontSize: 12,
      fontWeight: 'bold',
      backgroundColor: '#014c94',
      top: '30%',
    },
    taskIcon: {
      marginRight: 5,
      // marginBottom: '-7px',
      fontSize: 22,
    },
  }))(
    class Tasks extends Component {
      constructor(props) {
        super(props)
        this.myRef = createRef()
        this.state = {
          width: '100%',
          anchorEl: null,
        }
      }

      componentDidMount() {
        this.setState({ width: this?.myRef?.current?.offsetWidth - 30 })
      }

      handleClick = event => {
        this.setState({ anchorEl: event.currentTarget })
      }

      handleClose = () => {
        this.setState({ anchorEl: null })
      }

      render() {
        const {
          classes,
          // taskIDs,
          stageIdx,
          moveStageTask,
          toggleTaskModal,
          // tasksByID,
          // tasksLoaded,
          createOrUpdateCampaign,
          status,
          removeStageTask,
          update,
          stageId,
          campaignID,
          stepperGoTo,
          filteredTasks,
          addPlaceholderTask,
          taskTypes,
          filteredTemplates,
          filteredGroups,
          receiveTask,
        } = this.props

        return (
          <div ref={this.myRef} style={{ padding: 15, position: 'relative' }}>
            <div
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                paddingLeft: 16,
                marginBottom: 15,
              }}
            >
              {language.campaign.add.taskHeading}
            </div>
            <Button
              aria-owns={
                this.state.anchorEl
                  ? `campaign-funnel-tasks-popup-menu-${stageId}`
                  : undefined
              }
              aria-haspopup
              disabled={status === 'C'}
              color="secondary"
              className={classes.addButton}
              size="small"
              // onClick={() =>
              // 	// toggleTaskModal({
              // 	// 	stageIdx,
              // 	// })

              // 	addPlaceholderTask({ name: 'New stage task' }, stageIdx)
              // }
              onClick={this.handleClick}
            >
              <Add className={classes.addIcon} style={{ marginRight: 5 }} />
              {language.campaign.add.addTaskButton}
            </Button>
            <Menu
              id={`campaign-funnel-tasks-popup-menu-${stageId}`}
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl)}
              onClose={this.handleClose}
            >
              {Object.values(taskTypes || {}).map(taskType => {
                const disabled =
                  taskType.name === 'trigger.cmd.send.sms' &&
                  !this.props.approvedCampaignExists

                const menuItem = (
                  <MenuItem
                    disabled={disabled}
                    key={`${stageId}-${taskType?.display_name}`}
                    onClick={() => {
                      addPlaceholderTask(
                        {
                          taskTypeID: taskType?.id,
                          task_type_id: taskType?.id,
                        },
                        stageIdx,
                        taskType?.display_name,
                      )
                      this.handleClose()
                    }}
                  >
                    <EntityTypeIcon
                      entityType="task"
                      entityID={taskType.id}
                      className={classes.taskIcon}
                    />
                    {taskType?.display_name}
                  </MenuItem>
                )

                return disabled ? (
                  <ClickableTooltip
                    key={`${stageId}-${taskType?.display_name}-tooltip`}
                    content={<TooltipContent />}
                  >
                    {menuItem}
                  </ClickableTooltip>
                ) : (
                  menuItem
                )
              })}
            </Menu>
            <div>
              {filteredTasks.map((task, index) => (
                <Task
                  key={`campaignPageStage${stageIdx}Task${task?.id}`}
                  id={task?.id}
                  index={index}
                  task={task}
                  tasksLength={filteredTasks?.length}
                  width={this.state.width}
                  stageIdx={stageIdx}
                  moveStageTask={(dragIndex, hoverIndex) => {
                    if (status !== 'L' || status !== 'C') {
                      moveStageTask(stageIdx, dragIndex, hoverIndex)
                    }
                  }}
                  createOrUpdateCampaign={createOrUpdateCampaign}
                  classes={classes}
                  removeStageTask={removeStageTask}
                  update={update}
                  stageId={stageId}
                  campaignID={campaignID}
                  status={status}
                  toggleTaskModal={toggleTaskModal}
                  stepperGoTo={stepperGoTo}
                  template={filteredTemplates?.[task?.id]}
                  groupObj={filteredGroups?.[task?.id]}
                  receiveTask={receiveTask}
                />
              ))}
            </div>
          </div>
        )
      }
    },
  ),
)
